export default __webpack_public_path__ + "static/media/client8.e0f4d13e.jpg";